export default __webpack_public_path__ + "static/media/savanah.a5c7fd6c.png";